import { render } from "./InboundMappingTemplateManage.vue?vue&type=template&id=994e252e&scoped=true&ts=true"
import script from "./InboundMappingTemplateManage.vue?vue&type=script&lang=ts"
export * from "./InboundMappingTemplateManage.vue?vue&type=script&lang=ts"

import "./InboundMappingTemplateManage.vue?vue&type=style&index=0&id=994e252e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-994e252e"],['__file',"src/app/catalog/mapping-template/inbound/mapping-template-manage/InboundMappingTemplateManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "994e252e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('994e252e', __exports__)) {
    api.reload('994e252e', __exports__)
  }
  
  module.hot.accept("./InboundMappingTemplateManage.vue?vue&type=template&id=994e252e&scoped=true&ts=true", () => {
    api.rerender('994e252e', render)
  })

}


export default __exports__